import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addActivity } from 'bundles/apex/deals/show/store/activities/actions';

import Modal from 'bundles/apex/activities/modal';
import LogActivityModal from 'bundles/apex/activities/log_activity/modal';
import { buildActivity } from 'bundles/apex/activities/form/helpers';

export function ActivityCreationModal({ addActivity, contactDetailsRedesign, deal, show, onClose }) {
  if (contactDetailsRedesign) {
    return (
      <LogActivityModal
        path={deal.activitiesPath}
        show={show}
        subjectName={deal.name}
        onHide={onClose}
        onLogged={(activity) => {
          addActivity(activity);
          onClose();
        }}
      />
    );
  }

  return (
    <Modal
      activity={buildActivity(deal.activitiesPath, { availableTagsPath: deal.availableTagsPath })}
      header="Add an activity"
      show={show}
      onHide={onClose}
      onSave={addActivity}
    />
  );
}

ActivityCreationModal.propTypes = {
  addActivity: PropTypes.func.isRequired,
  contactDetailsRedesign: PropTypes.bool,
  deal: PropTypes.shape({
    activitiesPath: PropTypes.string.isRequired,
    availableTagsPath: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  contactDetailsRedesign: state.features.contactDetailsRedesign,
  deal: state.deal,
});

const mapDispatchToProps = {
  addActivity,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreationModal);
